import { getSessionId, getSessionStartTime, saveCurrentStep, getAuthXToken } from '@/services/auth'
import { NR_LOGIN_PASSWORD, NR_STEPS, NR_LOGIN_STEP, EMAIL_DOMAIN_SITEMINDER } from './constants'

/**
 * Tracks login password step in New Relic and updates session state.
 * Records the step progression and calculates duration from session start.
 */
export const nrLoginPassword = (): boolean => {
  try {

    const authxToken = getAuthXToken()

    if (authxToken && authxToken.payload.email.includes(EMAIL_DOMAIN_SITEMINDER)) {
      return false
    }

    const sessionId = getSessionId()
    const sessionStartTime = getSessionStartTime()

    const newrelic: any = (window as any).newrelic

    // Guard against invalid session start time
    if (!sessionStartTime || isNaN(Number(sessionStartTime))) {
      return false
    }

    const duration = Date.now() - Number(sessionStartTime)

    if (newrelic && sessionId) {
      newrelic.addPageAction(NR_LOGIN_STEP, { sessionId, step: NR_STEPS.LOGIN_PASSWORD })
      newrelic.addPageAction(NR_LOGIN_PASSWORD, { sessionId, durationMs: duration })
      saveCurrentStep(NR_STEPS.LOGIN_PASSWORD)
      return true
    }

    return false
  } catch {
    return false
  }
}
